import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';



export enum PaneType {
    left = 'left',
    center = 'center',
    right = 'right'
  }

